import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { HHIEButton } from '../../utility/HHIEButton';
import Loading from '../../utility/Loading';

export default function ManuallyOnboard(props) {
    const [show, setShow] = useState(false);
    // const [closeDisabled, setCloseDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resultMessage, setResultMessage] = useState("Press 'Run' to onboard any emails added in Admin Configs.");
    const [user, setUser] = useState(props.user);
    const [userIsAdmin, setUserIsAdmin] = useState(false);
    var disabled = false;

    useEffect(() => {
        try {
            setUser(props.user);
            setUserIsAdmin(CheckUserIsAdmin(props.user))
        }
        catch (ex) {
            console.error(ex);
        }
    }, []);

    const CheckUserIsAdmin = async (currentUser) => {
        const isAdmin =
            await fetch('api/admin/GetAdminRoleBySfId/' + currentUser.sfid)
                .then(async (isAdminResponse) => {
                    try {
                        return await isAdminResponse.json().then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            return json.message
                        });
                    }
                    catch (ex) {
                        return console.log(ex);
                    }
                })
                .catch((error) => {
                    console.log("Error getting a response: " + error);
                });
        setUserIsAdmin(isAdmin);
    }

    useEffect(() => {
        if (loading) {
            disabled = true;
            setResultMessage(<Loading message={<div>Checking for members to onboard. . . please wait</div>} />);
            const requestOptions = {
                method: "POST",
                headers: { "Content-type": "application/json: charset=UTF-8" }
            }
            fetch('api/admin/OnboardPocs/' + user.sfid, requestOptions)
                .then((response) => {
                    console.log(response)
                    response.json()
                        .then((result) => {
                            if (result.errors !== null && result.errors !== "") alert(result.errors)
                            console.log(result.message);
                            var resultArr = result.message.split("\n");
                            var displayArr = [];
                            resultArr.forEach((element, index) => {
                                displayArr.push(<div>{element}</div>);
                            })

                            setResultMessage(displayArr);
                        })
                        .catch((error) => {
                            console.log("json error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Response error: " + error);
                });
            setLoading(false);
            disabled = false;
        }
    }, [loading]);

    const handleClose = () => {
        setLoading(false);
        setShow(false);
        setResultMessage("Press 'Run' to onboard any emails added in Admin Configs.");
    };
    const handleShow = () => setShow(true);

    const handleOnboarding = () => {
        setLoading(true);
    };

    return (
        <>{userIsAdmin &&
            <>
                <HHIEButton
                    id="new-member-provision"
                    variant="outline-primary"
                    onClick={handleShow}
                    title="Onboard POCs"
                />
                <Modal
                    id="new-member-provision-modal"
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header>
                        <Modal.Title>Onboard POCs listed in Configs</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <div>{resultMessage}</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <HHIEButton
                            variant="warning"
                            disabled={disabled}
                            onClick={handleClose}
                            title="Close"
                        />
                        <HHIEButton
                            variant="primary"
                            onClick={handleOnboarding}
                            title="Run"
                        />
                    </Modal.Footer>
                </Modal>
            </>
        }
        </>
    );
}